import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import * as actions from 'actions'
import Question from './Question'

class FAQ extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: props.data,
      isScrollIntoView: props.isScrollIntoView
    }
  }
  scrollIntoViewIfNecessary() {
    if (this.state.isScrollIntoView) {
      this.props.dispatch(actions.token.toggleMinimizeAlert(true))
      setTimeout(() => {
        this.refs.faq.scrollIntoView()
      }, 1)
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data,
      isScrollIntoView: nextProps.isScrollIntoView
    })
  }
  componentDidMount() {
    this.scrollIntoViewIfNecessary()
  }
  componentDidUpdate() {
    this.scrollIntoViewIfNecessary()
  }
  render() {
    let data
    if (this.state && this.state.data) {
      data = this.state.data
    }

    let mobile
    if (window.innerWidth <= 480) {
      mobile = { display: 'none' }
    }

    return (
      <section className="main-grid center" ref="faq" id="faq">
        <ul className="grid group">
          <li className="grid-small">
            <h3><b>{data && data.title}</b></h3>
            <h3 className="sectra"><em>{data && data.subTitle}</em></h3>
          </li>

          <li className="grid-small grid-middle">
            <h3 className="sectra-light">
              <span>{data && data.english} {data && data.japanese}</span>
            </h3>

            <div className="mg-top-small">
              <p>{data && `${data.definition} `}<em>{data && data.wordType}</em></p>
              <ul className="small-ol">
                <li><p>{data && data.definition2}</p></li>
                <li><p>{data && data.definition3}</p></li>
              </ul>
            </div>
          </li>
        </ul>

        <ul className="grid group faq-questions">
          <li className="grid-small" style={mobile}>
            {
              data && data.questions && data.questions.map((question, i) => {
                if (i < Math.floor(data.questions.length / 3)) {
                  return <Question key={i} id={i + 1} question={question.question} answer={question.answer} />
                } else { return }
              })
            }
          </li>

          <li className="grid-small grid-middle">
            {
              data && data.questions && data.questions.map((question, i) => {
                if (i >= Math.floor(data.questions.length / 3) && i < (Math.floor(data.questions.length / 3) * 2)) {
                  return <Question key={i} id={i + 1} question={question.question} answer={question.answer} />
                } else { return }
              })
            }
          </li>

          <li className="grid-small">
            {
              data && data.questions && data.questions.map((question, i) => {
                if (i >= Math.floor(data.questions.length / 3) * 2) {
                  return <Question key={i} id={i + 1} question={question.question} answer={question.answer} />
                } else { return }
              })
            }
          </li>
        </ul>
      </section>
    )
  }
}
FAQ.contextTypes = {
}
FAQ.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    location: ownProps.location
  }
}

export default connect(mapStateToProps)(FAQ)



// WEBPACK FOOTER //
// ./src/components/Utils/FAQ.js